import React from 'react'
import { YStack } from 'tamagui'

interface ContentWrapperProps {
  children: React.ReactNode
  maxWidth?: number
  py?: string | number
  px?: number | string
}

export const ContentWrapper: React.FC<ContentWrapperProps> = ({
  children,
  maxWidth = 1140,
  py = '$4',
  px = 0,
}) => {
  return (
    <YStack>
      <YStack py={py} px={px} w="100%" maw={maxWidth} mx="auto">
        {children}
      </YStack>
    </YStack>
  )
}
